import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './Features.css';

const Features = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    const servicesRef = ref(database, 'services');
    const unsubscribe = onValue(servicesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const servicesList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setServices(servicesList);
      } else {
        setServices([]);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <section id="features" className="features">
      <div className="container">
        {services.length === 0 ? null : (
          <>
            <div className="section-header">
              <h2 className="section-title">Hizmetlerimiz</h2>
              <p className="section-subtitle">
                Bulut Ambalaj olarak sunduğumuz hizmetler
              </p>
            </div>
            <div className="features-grid">
              {services.map((service, index) => (
                <div key={service.id || index} className="feature-card">
                  <h3 className="feature-title">{service.title}</h3>
                  <p className="feature-description">{service.description}</p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Features;
